var map = {
	"./Euro.svg": "45a1",
	"./MoonBook.svg": "4666",
	"./Smartphone.svg": "afd7",
	"./accessibility.svg": "0d09",
	"./iPhone.svg": "e533",
	"./magnifying-glass.svg": "f722",
	"./notes.svg": "2670",
	"./percentage.svg": "e11a",
	"./printer.svg": "3df6",
	"./sim_card.svg": "b57e",
	"./spark.svg": "9c29",
	"./support_chat.svg": "26c5",
	"./template3/navbar/callingcards.svg": "0089",
	"./template3/navbar/cashcards.svg": "bdbc",
	"./template3/navbar/dr.svg": "6370",
	"./template3/navbar/flixbus.svg": "18b6",
	"./template3/navbar/giftcards.svg": "f084",
	"./template3/navbar/invoices.svg": "e5d2",
	"./template3/navbar/ir.svg": "2c2e",
	"./template3/navbar/reclaim.svg": "073f",
	"./template3/navbar/reports.svg": "abde",
	"./template3/navbar/users.svg": "40b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "00292";